export const getPercentageMaximumFractionDigits = (value: number): number => {
  if (value < 0.1) {
    return 2
  } else if (value < 1) {
    return 1
  } else {
    return 0
  }
}
